export default [
    {
        path:"/delivery-management",
        name:"delivery",
        meta: {
            title:"DELIVERY LOCATIONS"
        },
        component : () => import ("../views/delivery/location.vue")
    },
   
]